'use strict';

var isNode = typeof document === 'undefined';

var _ = require('lodash');
var Classnames = require('classnames');
import { DetectIE } from '../../../../common-js/helpers';
var jQuery = require('jquery');
var React = require('react');
var ReactRouter = require('react-router');
var ReactDOM = require('react-dom');
var SuperAgent = require('superagent');
var LinkedStateMixin = require('react-addons-linked-state-mixin');

if (!isNode) {
    var Spinner = require('spin');
}

var Constants = require('../constants');
var Events = require('../events');
var Global = require('../global');
var LinkTile = require('./linktile.jsx');

var History = ReactRouter.History;

var CollectionLinkTile = LinkTile.CollectionLinkTile;
var CollectionPageLinkTile = LinkTile.CollectionPageLinkTile;
var HomepageLinkTile   = LinkTile.HomepageLinkTile;
var MediaLinkTile      = LinkTile.MediaLinkTile;
var ResponsiveMixin    = Global.ResponsiveMixin;

var DynamicLayout = require('../../../../common-js/dynamic-layout/dynamic-layout.js');

if (!isNode) {
    require('./thumb-grids.scss');
}

// Homepage linktiles
// 2-3-4-4
// Custom alt
var HeroTieredThumbs = React.createClass({
    render: function() {
        var thumbs = this.props.thumbs.map(t => {
            return (
                <HomepageLinkTile   key            = {t.listing_id}
                                    target         = {t.url}
                                    urlkey         = {t.urlkey}
                                    order_idx      = {t.seq}
                                    alt            = {t.img_alt}
                                    img_src        = {t.img_src}
                                    singlePageLink = {false}
                                    source         = 'homepage'>
                    {t.listing_name}
                </HomepageLinkTile>
            );
        });
        var tier0 = _.slice(thumbs, 0, 1);
        var tier1 = _.slice(thumbs, 1, 3);
        var tier2 = _.slice(thumbs, 3, 6);
        var tier3 = _.slice(thumbs, 6);
        return (
            <div className='global-tiers'>
                <div className='global-tiers-0'>
                    {tier0}
                </div>
                <div className='global-tiers-1'>
                    {tier1}
                </div>
                <div className='global-tiers-2'>
                    {tier2}
                </div>
                <div className='global-tiers-3'>
                    {tier3}
                </div>
            </div>
        );
    }
});

// Collection listing top-level
// 3-3-3-4
var TieredThumbs = React.createClass({
    render: function() {
        var thumbs = this.props.thumbs.map(t => {
            return (
                <CollectionPageLinkTile key            = {t.listing_id}
                                    target         = {t.url}
                                    urlkey         = {t.urlkey}
                                    order_idx      = {t.seq}
                                    alt            = {t.img_alt}
                                    img_src        = {t.img_src}
                                    singlePageLink = {true}
                                    source         = 'collection'>
                    {t.listing_name}
                </CollectionPageLinkTile>
            );
        });
        var tier2 = _.slice(thumbs, 0, 6);
        var tier3 = _.slice(thumbs, 6);
        return (
            <div className='global-tiers'>
                <div className='global-tiers-2'>
                    {tier2}
                </div>
                <div className='global-tiers-3'>
                    {tier3}
                </div>
            </div>
        );
    }
});

// Fixed grid, i.e. Office Chairs
var GridThumbs = React.createClass({
    render: function() {
        var thumbs = this.props.thumbs.map(t => {
            const file = this.props.overrideIcon ? this.props.overrideIcon : t.urlkey;
            return (
                <CollectionLinkTile key            = {t.urlkey}
                                    target         = {t.url}
                                    urlkey         = {t.urlkey}
                                    alt            = {t.name}
                                    singlePageLink = {true}
                                    source         = 'collection'>
                    {t.name}
                </CollectionLinkTile>
            );
        });
        return (
            <div className='cs-thumbgrid global-tiers'>
                <div className='global-tiers-2'>
                    {thumbs}
                </div>
            </div>
        );
    }
});

// Dynamic-width images, i.e. any Collection listing
var DynamicThumbs = React.createClass({
    mixins: [ ResponsiveMixin, History ],

    _increments: [ 5, 5, 10, 10, 20, 40 ],

    getInitialState: function() {
        var incPtr = 0,
            count = this._increments[incPtr];

        // If query string contains page number, load this many items
        if (!isNode) {
            var pageRE = window.location.pathname.match(/&page=(\d+)$/);
            if (pageRE) {
                var page = pageRE[1];
                while (--page > 0) {
                    ++incPtr;
                    count += this._increments[incPtr];
                }
            }
        }

        return {
            // Rows visible in list
            count: count,

            // Read _increments[incPtr] more thumbs when Show More pressed
            incPtr: incPtr,

            // Calculated rows
            rows: Payload.rows ? Payload.rows : [],

            // 'loading' spinner
            showSpinner: false,
        }
    },
    componentWillMount: function() {
        this.setState({
            lastViewportWidth: this.state.viewportWidth,
        });
        this._dynamic_layout();
        if (!isNode) {
            Events.Actions.setTopButtonVisible(true);
        }
    },
    componentDidMount: function() {
        Payload.rows = null;
    },
    componentWillUnmount: function() {
        Events.Actions.setTopButtonVisible(false);
    },
    componentDidUpdate: function(prevProps, prevState) {
        // Change category
        if (prevProps.category.title != this.props.category.title) {
            // If re-route to original Category, reload from Payload
            this.setState(this.getInitialState(), this._dynamic_layout);
        }
        if (!prevState.showSpinner && this.state.showSpinner) {
            new Spinner({
                color: 'white',  // spinner color
            }).spin(this.refs.spinner);
        }
    },
    componentDidResize: function() {
        if (this.state.viewportWidth != this.state.lastViewportWidth) {
            this.setState({
                rows: [],
                lastViewportWidth: this.state.viewportWidth,
            }, this._dynamic_layout);
        }
    },
    _dynamic_layout: function() {
        var _this = this;

        var params;
        if (this.state.viewportLayout == 'desktop') {
            params = {
                thumbs: this.props.thumbs,
                width: 1150,
                targetHeight: 250,
                gap: 8,
            };
        } else {
            params = {
                thumbs: this.props.thumbs,
                width: this.state.viewportWidth,
                targetHeight: this.state.viewportLayout == 'portrait' ? this.state.viewportHeight / 3 : this.state.viewportHeight / 2,
                gap: 4,
            };            
        }

        // Show loading spinner after 0.5 sec
        setTimeout(function() {
            if (!_this.state.rows.length && !isNode) {
                _this.setState({
                    showSpinner: true,
                });
            }
        }, 500);

        // If rotation happens during calculation, don't display invalidated layout
        var cached_width = this.state.viewportWidth;

        DynamicLayout.Distribute(params, rows => {
            // if (cached_width && this.state.viewportWidth != cached_width) {
            //     return;  // another calculation will be in progress
            // }

            if (isNode) {
                Inject.rows = rows;
            }

            _this.setState({
                showSpinner: false,
                rows: rows,
                count: rows.length < _this.state.count ? rows.length
                                                       : _this.state.count,
            }, function() {
                // If user presses back from Product Detail, restore scroll position (as saved into DOM history state by LinkTile's onClick) #228
                if (history.state && history.state.scrollTop) {
                    jQuery(window).scrollTop(history.state.scrollTop);
                }
            });
        });
    },
    _handleLoadMore: function() {
        var incPtr = Math.min(this._increments.length-1, this.state.incPtr+1);
        this.setState({
            incPtr: incPtr,
            count: this.state.count + this._increments[incPtr],
        }, function() {
            this._dynamic_layout();

            // Increment query string page number
            var ieVersion = DetectIE();
            if (ieVersion === false || ieVersion > 9) {
                var p = window.location.pathname.replace(/\&page=\d+$/, '');
                var q = `${p}&page=${incPtr + 1}`;
                this.history.replaceState(null, q);
            }
        });
    },
    render: function() {
        if (this.state.showSpinner) {
            return (
                <div className='cs-thumbgrid'>
                    <div className='cs-dynamic'>
                        <div className='cs-dynamic-spinner' ref='spinner' />
                    </div>
                </div>
            );
        }
        if (!this.state.rows.length) {
            return null;
        }

        var _this = this;
        var key = 0;
        var rows = this.state.rows.slice(0, this.state.count).map(row => {
            var thumbs = row.map(T => {
                const file = _this.props.overrideIcon ? _this.props.overrideIcon : _this.props.category.urlkey;

                // T.name used in case of Quick Ship to drop leading Q; T.id used otherwise.
                // Label omitted entirely on mobile, so not as to occlude photo.

                return (
                    <MediaLinkTile key={T.id} object={T}>
                        {this.state.viewportLayout == 'desktop' && (
                            T.name ? T.name : T.id
                        )}
                    </MediaLinkTile>
                );
            });
            return (
                <div key={key++} className='cs-dynamic-row'>
                    {thumbs}
                </div>
            );
        });
        return (
            <div className='cs-thumbgrid'>
                <div className='cs-dynamic'>
                    {rows}

                    {this.state.rows.length > this.state.count ?
                        <div className='cs-dynamic-showmore' onClick={this._handleLoadMore}>
                            {/* TO DO: webp */}
                            <img src={Constants.static + 'images/collection/showmore.png'} alt='show more images' width="50" height="16"/>
                            SHOW MORE
                        </div>
                    : null}
                </div>
            </div>
        );
    }
});

var Thumbs = React.createClass({
    propTypes: {
        type: React.PropTypes.oneOf(['hero-tiered', 'tiered', 'grid', 'dynamic']).isRequired,
        overrideIcon: React.PropTypes.string,
        thumbs: React.PropTypes.array,
    },
    render: function() {
        switch (this.props.type) {
        case 'hero-tiered':
            return <HeroTieredThumbs thumbs={this.props.thumbs} />;
        case 'tiered':
            return <TieredThumbs thumbs={this.props.thumbs} />;
        case 'grid':
            return <GridThumbs thumbs       = {this.props.thumbs}
                               overrideIcon = {this.props.overrideIcon} />;
        case 'dynamic':
            return <DynamicThumbs category     = {this.props.category}
                                  thumbs       = {this.props.thumbs}
                                  overrideIcon = {this.props.overrideIcon} />;
        }
    }
});

module.exports = Thumbs;



// WEBPACK FOOTER //
// ./src/collections/thumb-grids.jsx